// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1aVkL","footer":"ReportModalFilter_footer__3zFn8"};